export default __webpack_public_path__ + "cddb689ecca7e65339aa548f91e92db1.svg";